module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921085651_T.440d2dc7.jpg";